// extracted by mini-css-extract-plugin
module.exports = {"model":"PasswordChange_model__2hvbX","content":"PasswordChange_content__1jEoB"};